import groq from 'groq';

export const blockCookieListFields = groq`
  // No fields needed for CookieList
`;
